<template>
    <section
        class="translate-z-0 relative isolate transform-gpu overflow-hidden">
        <div
            class="translate-z-0 absolute -left-1/3 top-1/2 size-1/2 -translate-y-1/2 transform-gpu rounded-full bg-accent/30 blur-[6rem] delay-700 will-change-transform max-lg:hidden" />
        <div
            class="translate-z-0 absolute right-0 top-1/2 size-1/4 -translate-y-1/2 transform-gpu rounded-full bg-accent/30 blur-[6rem] delay-300 will-change-transform max-lg:hidden" />

        <div class="container relative overflow-hidden">
            <div class="mx-auto max-w-screen-md text-left md:text-center">
                <AtomTitle>Наша команда</AtomTitle>
                <div
                    class="mt-5 space-y-6 text-16/148 text-accent-100 md:mt-10 md:text-20/120">
                    <p>
                        У&nbsp;нас работает налаженная система обучения
                        и&nbsp;аттестации сотрудников для обеспечения высоких
                        единых стандартов работы. Уделяем особое внимание
                        балансу технической грамотности и&nbsp;эффективного
                        менеджмента в&nbsp;нашей специфической сфере.
                    </p>
                    <p v-if="isCromiMode">
                        За&nbsp;каждым этапом поставки следит персональный
                        менеджер, к которому&nbsp;Вы можете обратиться
                        в&nbsp;любое время для решения возникшего вопроса,
                        в&nbsp;том числе через удобный для вас мессенджер.
                    </p>
                    <p v-else>
                        За&nbsp;каждым этапом организации мероприятия следит
                        персональный менеджер, к которому&nbsp;Вы можете
                        обратиться в&nbsp;любое время для решения возникшего
                        вопроса, в&nbsp;том числе через удобный для вас
                        мессенджер.
                    </p>
                </div>
            </div>
            <OurTeamSlider :items="employees?.data || items" />
            <div
                v-if="!hideAboutButton"
                class="mt-10 text-center md:mt-20">
                <BaseLink
                    to="/about"
                    target="_blank"
                    icon-right="arrow-right"
                    size="accent">
                    Узнать больше
                </BaseLink>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import AtomTitle from '~/components/atom/atom-title/AtomTitle.vue'
import BaseLink from '~/components/base/base-link/BaseLink.vue'

import OurTeamSlider from './OurTeamSlider.vue'
import type { Employee } from './our-team.types'

const props = defineProps({
    items: {
        type: Array as PropType<Employee[]>,
        default: () => [],
    },
    hideAboutButton: {
        type: Boolean as PropType<boolean>,
        default: false,
    },
    slug: {
        type: String as PropType<string>,
        default: null,
    },
})

const isCromiMode = computed(() => {
    return isCromi()
})

const { data: employees, execute } = await useApiFetch<Include<Employee[]>>(
    `/v1/employees/${props.slug}`,
    {
        server: false,
        immediate: false,
    }
)

onMounted(async () => {
    if (props.slug) {
        await execute()
    }
})
</script>
